// import { CanActivateFn } from '@angular/router';
// import { inject } from '@angular/core';
// import { Router } from '@angular/router';

// export const authGuard: CanActivateFn = (route, state) => {
//   const router = inject(Router);
//   if (typeof window !== 'undefined' && window.localStorage) {
//   const isAuthenticated = !!localStorage.getItem('Admin_User') || null; // Example: Check for a token

//   if (!isAuthenticated) {
//     // Redirect to login if not authenticated
//     router.navigate(['/'], { queryParams: { returnUrl: state.url } });
//     return false;
//   }
//   }
//   return true;
// };

import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../_services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    router.navigate(['/'], {
      queryParams: { returnUrl: state.url },
      replaceUrl: true,
    });
    return false;
  }

  return true;
};

